// @ts-nocheck
import {Percent, CurrencyUSD, Time, GraphQLDecimal} from '@/graphql/scalars'

import * as Types from '../../../../../types/schema';

import { ClientProfessionalTeam_ClientProfileFragment, ClientProfessionalTeam_ClientOrganizationFragment } from './ClientProfessionalTeam.generated';
import { gql } from '@apollo/client';
import { ClientProfessionalTeam_ClientProfileFragmentDoc, ClientProfessionalTeam_ClientOrganizationFragmentDoc } from './ClientProfessionalTeam.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type UpdateClientProfessionalTeamMutationVariables = Types.Exact<{
  householdId: Types.Scalars['ID']['input'];
  clientProfileInputs: Array<Types.AugmentedUpdateClientProfileInput> | Types.AugmentedUpdateClientProfileInput;
  clientOrganizationInputs: Array<Types.AugmentedUpdateClientOrganizationInput> | Types.AugmentedUpdateClientOrganizationInput;
}>;


export type UpdateClientProfessionalTeamMutation = { __typename?: 'Mutation', updateClientProfiles: Array<(
    { __typename?: 'ClientProfile', id: string }
    & ClientProfessionalTeam_ClientProfileFragment
  ) | null>, updateClientOrganizations: Array<(
    { __typename?: 'ClientOrganization', id: string }
    & ClientProfessionalTeam_ClientOrganizationFragment
  )> };

export const Operations = {
  Mutation: {
    UpdateClientProfessionalTeam: 'UpdateClientProfessionalTeam' as const
  }
}

/**
 * Custom plugin to wrap useQuery hooks with automatic context.fetchPolicy injection
 */
function withFetchPolicyContext(options) {
  const fetchPolicy = options?.fetchPolicy ?? 'cache-first';
  const isLazy = options?.isLazy ?? undefined;
  return {
    ...options,
    context: {
      ...options?.context,
      fetchPolicy,
      isLazy,
    },
  };
}

/**
 * Defaults useSubscription to ignoreResults: true so Apollo skips its
 * per-message useSyncExternalStore notification (forceStoreRerender). All
 * call sites manage state via onData; opting out avoids render storms when
 * messages arrive in a synchronous burst. See T2-10011. Callers that need
 * Apollo to surface data/loading/error can override by passing
 * ignoreResults: false explicitly.
 */
function withSubscriptionIgnoreResults(options) {
  return {
    ignoreResults: true,
    ...options,
  };
}


export const UpdateClientProfessionalTeamDocument = gql`
    mutation UpdateClientProfessionalTeam($householdId: ID!, $clientProfileInputs: [AugmentedUpdateClientProfileInput!]!, $clientOrganizationInputs: [AugmentedUpdateClientOrganizationInput!]!) {
  updateClientProfiles(householdId: $householdId, inputs: $clientProfileInputs) {
    id
    ...ClientProfessionalTeam_ClientProfile
  }
  updateClientOrganizations(inputs: $clientOrganizationInputs) {
    id
    ...ClientProfessionalTeam_ClientOrganization
  }
}
    ${ClientProfessionalTeam_ClientProfileFragmentDoc}
${ClientProfessionalTeam_ClientOrganizationFragmentDoc}`;
export type UpdateClientProfessionalTeamMutationFn = Apollo.MutationFunction<UpdateClientProfessionalTeamMutation, UpdateClientProfessionalTeamMutationVariables>;

/**
 * __useUpdateClientProfessionalTeamMutation__
 *
 * To run a mutation, you first call `useUpdateClientProfessionalTeamMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateClientProfessionalTeamMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateClientProfessionalTeamMutation, { data, loading, error }] = useUpdateClientProfessionalTeamMutation({
 *   variables: {
 *      householdId: // value for 'householdId'
 *      clientProfileInputs: // value for 'clientProfileInputs'
 *      clientOrganizationInputs: // value for 'clientOrganizationInputs'
 *   },
 * });
 */
export function useUpdateClientProfessionalTeamMutation(baseOptions?: Apollo.MutationHookOptions<UpdateClientProfessionalTeamMutation, UpdateClientProfessionalTeamMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateClientProfessionalTeamMutation, UpdateClientProfessionalTeamMutationVariables>(UpdateClientProfessionalTeamDocument, options);
      }
export type UpdateClientProfessionalTeamMutationHookResult = ReturnType<typeof useUpdateClientProfessionalTeamMutation>;
export type UpdateClientProfessionalTeamMutationResult = Apollo.MutationResult<UpdateClientProfessionalTeamMutation>;
export type UpdateClientProfessionalTeamMutationOptions = Apollo.BaseMutationOptions<UpdateClientProfessionalTeamMutation, UpdateClientProfessionalTeamMutationVariables>;